import { Button, ButtonVariant, Input } from '@egw/components'
import { Trans, useTranslation } from '@egw/i18n'
import { type FC } from 'react'
import { useFormContext } from 'react-hook-form'
import { UpdateEmailField, type UpdateEmailStep, UpdateEmailStepEnum } from '../../types/email/email-types'

export const VerifyEmailStep: FC<UpdateEmailStep> = ({ isLoading, ctaOnClick, resendCode }) => {
  const STEP = UpdateEmailStepEnum.VERIFY

  const { getValues, register } = useFormContext()

  const { t } = useTranslation('features-settings')

  const email = getValues(UpdateEmailField.EMAIL) as string

  return (
    <div className="flex flex-col gap-4">
      <Trans
        className="fs-exclude"
        i18nKey={t(`update_email.${STEP}.description`)}
        values={{ email }}
        components={{ b: <strong />, s: <span /> }}
      />
      <Input
        {...register(UpdateEmailField.OTP_CODE)}
        id={UpdateEmailField.OTP_CODE}
        label={t(`update_email.${STEP}.input_label`)}
      />
      <button
        type="button"
        onClick={resendCode}
        className="!justify-start text-left text-action font-semibold text-base"
        id="resendCode"
      >
        {t('settings.personal_info.change.resend_code')}
      </button>
      <Button variant={ButtonVariant.Primary} isLoading={isLoading} id="changeEmailContinue" onClick={ctaOnClick}>
        {t('settings.personal_info.change.continue')}
      </Button>
    </div>
  )
}
